import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';
import { getUserCompany, getUserProfile } from '../store';
export function useGATrackUserData(appIsReady) {
    const userProfile = useSelector(getUserProfile);
    const userCompany = useSelector(getUserCompany);
    useLayoutEffect(() => {
        if (appIsReady) {
            if (window.gtag) {
                if (userProfile && userCompany) {
                    window.gtag('set', 'user_properties', {
                        userId: userProfile.id,
                        companyId: userCompany.id,
                        personas: userProfile.personas,
                        companyName: userCompany.companyName,
                        areaOfInterest: userProfile.areaOfInterest,
                        creationDate: userCompany.createdAt,
                        locale: userProfile.locale || '',
                        city: userProfile.city || '',
                        state: userProfile.state || '',
                        zipCode: userProfile.zipCode || '',
                    });
                }
                else {
                    console.warn("User info not available, can't track user data on GA.");
                }
            }
            else {
                console.warn('GA not initialized.');
            }
        }
        return;
    }, [userProfile, userCompany, appIsReady]);
}
//# sourceMappingURL=useGATrackUserData.js.map